import { OverlayType } from "@/types/state";
import WifiIcon from "@/components/icons/WifiIcon";
import { useGameStore } from "@/state/gameStore";
import { useUnlockedAchievements } from "@/state/selectors";
import BatteryIcon from "@/components/icons/BatteryIcon";
import CashCtrlWordmark from "@/components/logos/CashCtrlWordmark";
import AchievementBadge from "@/components/screens/PlayingScreen/components/AchievementsPanel/AchievementBadge";
import { motion } from "framer-motion";

const PlayScreenHeader = () => {
    const setOverlay = useGameStore((state) => state.setOverlay);
    const unlockedAchievements = useUnlockedAchievements();
    const hasEarnedAchievements = unlockedAchievements.length > 0;
    const gameIsFinished = useGameStore((state) => state.gameIsFinished);

    return (
        <div className="absolute z-10 w-full">
            <motion.div
                className="absolute size-full bg-linear-to-b from-black/65 to-black/0 h-[180px]"
                initial={{ opacity: 0 }}
                animate={{ opacity: gameIsFinished ? 0 : 1 }}
                transition={{ duration: gameIsFinished ? 1 : 0.3 }}
            />
            <div className="mx-4 grid max-w-md grid-cols-3 items-center mt-4 z-10 isolate">
                <motion.div
                    className="flex items-center justify-start gap-x-1"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: gameIsFinished ? 0 : 1 }}
                    transition={{ duration: gameIsFinished ? 1 : 0.3 }}
                >
                    <BatteryIcon className="text-white" />
                    <WifiIcon width={12} height={12} className="text-white" />
                </motion.div>
                <motion.div
                    className="flex items-center justify-center"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: gameIsFinished ? 0 : 1 }}
                    transition={{ duration: gameIsFinished ? 1 : 0.3 }}
                >
                    <CashCtrlWordmark />
                </motion.div>
                <div className="flex justify-end">
                    <AchievementBadge
                        visible={hasEarnedAchievements || gameIsFinished}
                        onClick={() => setOverlay(OverlayType.Achievements)}
                    />
                </div>
            </div>
        </div>
    );
};

export default PlayScreenHeader;